// extracted by mini-css-extract-plugin
export default {"body":"Steps_body__UmQle","inactive":"Steps_inactive__uAf5l","active":"Steps_active__DYHkR"};